import React, { useState, useCallback } from 'react';
import { Box, Tooltip, IconButton } from '@mui/material';
import ResponsiveTypography from '@/components/ui/responsive-typography';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useTitleStyle } from '@/utils';
import { useTranslation } from 'react-i18next';

interface RegistrationLinkProps {
  registerLink: string;
}

const RegistrationLink: React.FC<RegistrationLinkProps> = ({
  registerLink
}) => {
  const { t } = useTranslation();
  const linkStyle = useTitleStyle('34ch', undefined, 'md', false);
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const handleCopyLink = useCallback(() => {
    navigator.clipboard.writeText(registerLink).then(() => {
      setIsLinkCopied(true);
      setTimeout(() => setIsLinkCopied(false), 2000);
    });
  }, [registerLink]);

  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="center"
      alignItems="center"
      marginTop={2}
    >
      <ResponsiveTypography sx={linkStyle} smallerXs>
        <span style={{ fontWeight: 'bold' }}>{t('registration_link')} </span>
        {' - '} {registerLink}
      </ResponsiveTypography>
      <Tooltip title={t('link_copied')} open={isLinkCopied} placement="top">
        <IconButton onClick={handleCopyLink}>
          {isLinkCopied ? <CheckIcon /> : <ContentCopyIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default RegistrationLink;
